<template>
  <div class="p-4">
    <l-l-selection @click="onSelectionClick" class="mb-4" :networks="networks" />

    <hot-table :data="datasets" :settings="settings" v-show="datasets.length > 0">
      <hot-column title="Id" data="id" read-only="true"></hot-column>
      <hot-column title="Station" data="station" read-only="true"></hot-column>
      <hot-column title="Pollutant" data="pollutant" read-only="true"></hot-column>
      <hot-column title="Month" data="month" :renderer="monthRenderer" read-only="true"></hot-column>
      <hot-column title="Verified" data="verified" type="numeric" read-only="true"></hot-column>
      <hot-column title="Pre verified" data="pre_verified" type="numeric" read-only="true"></hot-column>
      <hot-column title="Not verified" data="not_verified" type="numeric" read-only="true"></hot-column>
      <hot-column title="Action" data="action" read-only="true">
        <l-l-button-renderer hot-renderer></l-l-button-renderer>
      </hot-column>
    </hot-table>
  </div>
</template>

<script>
import VerifyService from "@/helpers/services/qualitycontrol/verify.service";
import LLSelection from "./LLSelection";
import LLButtonRenderer from "./LLButtonRenderer";

import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";

import Notify from "@/helpers/notify";

export default {
  name: "Verify",
  components: {
    LLSelection,
    HotTable,
    HotColumn,
    LLButtonRenderer
  },
  data() {
    return {
      monthRenderer: HandsontableHelper.monthRenderer,
      networks: [],
      datasets: [],
      settings: HandsontableHelper.settings()
    };
  },
  mounted() {
    this.settings.columnSorting = {
      sortEmptyCells: true,
      initialConfig: { column: 1, sortOrder: "asc" }
    };

    Notify.loadData(null, this.loadNetworks);
  },

  methods: {
    onSelectionClick(selection) {
      Notify.loadData(
        null,
        this.loadDatasets,
        selection.network,
        selection.year
      );
    },
    async loadNetworks() {
      this.networks = await VerifyService.networks();
    },
    async loadDatasets(network, year) {
      this.datasets = [];
      this.datasets = await VerifyService.datasets(network, year);
    },
    async loadPollutants() {
      this.pollutants = await EeaService.pollutants();
    }
  }
};
</script>

